var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("通知管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: { content: _vm.title },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入标题" },
                          model: {
                            value: _vm.ruleForm1.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name", $$v)
                            },
                            expression: "ruleForm1.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转地址", prop: "url" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入跳转地址" },
                          model: {
                            value: _vm.ruleForm1.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "url", $$v)
                            },
                            expression: "ruleForm1.url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type", $$v)
                              },
                              expression: "ruleForm1.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "系统通知", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "任务通知", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "通道类型", prop: "type1" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.type1,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type1", $$v)
                              },
                              expression: "ruleForm1.type1",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "短信通道", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "极光推送通道", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "环信IM", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm1.type1 == "2"
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: "短信模板号", prop: "templateNo" },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入短信模板号" },
                              model: {
                                value: _vm.ruleForm1.templateNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "templateNo", $$v)
                                },
                                expression: "ruleForm1.templateNo",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发送对象", prop: "send" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.send,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "send", $$v)
                              },
                              expression: "ruleForm1.send",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全体", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "客户", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "所有保安", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "临勤", value: "3" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发送机型", prop: "send" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.systemType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "systemType", $$v)
                              },
                              expression: "ruleForm1.systemType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "所有", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "IOS", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "Android", value: "2" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "版本要求", prop: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.versionCondition,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "versionCondition", $$v)
                              },
                              expression: "ruleForm1.versionCondition",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "无", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "<", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "<=", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "=", value: "3" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: ">", value: "4" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: ">=", value: "5" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { placeholder: "请输入版本号" },
                          model: {
                            value: _vm.ruleForm1.versionNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "versionNo", $$v)
                            },
                            expression: "ruleForm1.versionNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: { label: "是否循环", prop: "select" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm1.select,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "select", $$v)
                              },
                              expression: "ruleForm1.select",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发送时间", prop: "time" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间",
                          },
                          on: { change: _vm.selectTime },
                          model: {
                            value: _vm.ruleForm1.time,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "time", $$v)
                            },
                            expression: "ruleForm1.time",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上传图片", prop: "img" } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader",
                            staticStyle: { "margin-right": "auto" },
                            attrs: {
                              "list-type": "picture-card",
                              action: _vm.uploadUrl,
                              headers: _vm.deader,
                              "on-success": _vm.handleAvatarSuccess,
                              multiple: true,
                              "file-list": _vm.ruleForm1.img,
                              limit: 5,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "通知内容", prop: "memo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入通知内容",
                          },
                          model: {
                            value: _vm.ruleForm1.memo,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "memo", $$v)
                            },
                            expression: "ruleForm1.memo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm1("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }